'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'

/**
 * React Query Provider
 * 
 * 무한 스크롤 및 데이터 페칭을 위한 React Query 설정
 * 
 * @see https://tanstack.com/query/latest/docs/react/overview
 */
export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1분간 캐시 유지
            refetchOnWindowFocus: false, // 창 포커스 시 자동 재조회 비활성화
            retry: 1, // 실패 시 1번만 재시도
          },
        },
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}

